import { Link } from "react-router-dom";
import { ArrowRight, CheckCircle2 } from "lucide-react";
import { useSEO } from "../lib/useSEO";

const COMMITMENTS = [
  "Strictly obey all laws and regulations that are applicable",
  "Attempt to best utilize all management resources to achieve quality and continually strive to improve our performance",
  "Inform everyone in our organization and all other interested parties of our quality objectives and our performance in light of these objectives.",
  "Take every possible measure to provide safety for all employees, associates, subcontractors, and any other people who come in touch with our work or our work sites.",
  "Cooperate and collaborate with suppliers and customers to uphold and practice the highest standards of quality.",
  "Consistently evaluate business decisions by taking their possible quality impacts into account, now and in the future.",
  "Including quality management concerns and responsibilities in all staff training.",
];

export default function QualityPolicyPage() {
  useSEO({
    title: "Quality Policy — Health, Safety & Environment",
    description: "USI Security Ltd's Quality Policy: our commitment to health, safety, quality and the protection of the environment across all UK private security operations.",
    path: "/quality-policy",
  });
  return (
    <div data-testid="quality-page" className="pt-24">
      {/* Hero */}
      <section className="relative py-20 lg:py-24 border-b border-white/10">
        <div className="absolute inset-0 grid-bg opacity-30" />
        <div className="relative max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-8">
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-cyan-400 mb-4">◆ Standards</p>
            <h1 className="font-display font-extrabold text-white text-4xl sm:text-5xl lg:text-7xl leading-[1.02] tracking-tighter">
              Quality Policy
            </h1>
            <p className="mt-5 text-lg text-slate-400">Guaranteed quality and environment protection.</p>
          </div>
          <div className="lg:col-span-4 flex lg:justify-end">
            <Link to="/contact" data-testid="quality-cta" className="inline-flex items-center gap-2 border border-white/20 hover:border-cyan-400/50 hover:bg-white/5 text-white font-medium rounded-md px-5 py-3 text-sm transition">
              Get In Touch <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </section>

      {/* Body */}
      <article className="max-w-3xl mx-auto px-5 lg:px-8 py-16 lg:py-20 space-y-12">
        <section>
          <h2 className="font-display font-bold text-white text-2xl lg:text-3xl tracking-tight mb-4">Our Guarantee</h2>
          <p className="text-slate-300 text-lg leading-relaxed">
            Ultimate Solutions In Security LTD Acknowledges that an essential management function is overseeing and guaranteeing health, safety, quality, and the protection of the environment. We see these things as a vital part of our responsibilities and adopt these quality standards as integral to running a good business.
          </p>
        </section>

        <section>
          <h2 className="font-display font-bold text-white text-2xl lg:text-3xl tracking-tight mb-6">We will always:</h2>
          <ul className="space-y-4">
            {COMMITMENTS.map((c, i) => (
              <li key={i} data-testid={`commit-${i}`} className="card-tech rounded-lg p-5 flex items-start gap-4">
                <CheckCircle2 className="w-5 h-5 text-emerald-400 mt-0.5 shrink-0" />
                <span className="text-slate-200 leading-relaxed">{c}</span>
              </li>
            ))}
          </ul>
        </section>

        <section className="pt-6 border-t border-white/10">
          <p className="font-mono text-sm text-slate-400">Checked and approved by the Managing Director on 19th January 2023</p>
        </section>
      </article>
    </div>
  );
}
